import React from 'react';
import { Avatar, SxProps, Theme, alpha, useTheme } from '@mui/material';

import { personPhotoUrl } from '../../utils/personPhoto';

/** "Ayesha Khan" → "AK". */
export const nameInitials = (name?: string | null): string =>
  (name || '?').trim().split(/\s+/).slice(0, 2).map(w => w[0]?.toUpperCase()).join('') || '?';

/**
 * A person's profile photo, or their initials on a soft primary tint when
 * there is none. `src` (e.g. a local preview) wins over `photoFilename`.
 */
const PersonAvatar: React.FC<{
  name?: string | null;
  photoFilename?: string | null;
  src?: string;
  size?: number;
  sx?: SxProps<Theme>;
}> = ({ name, photoFilename, src, size = 40, sx }) => {
  const theme = useTheme();
  return (
    <Avatar
      src={src ?? personPhotoUrl(photoFilename)}
      alt={name || undefined}
      sx={[
        {
          width: size, height: size, fontSize: size * 0.36, fontWeight: 700,
          bgcolor: alpha(theme.palette.primary.main, 0.12), color: 'primary.main',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {nameInitials(name)}
    </Avatar>
  );
};

export default PersonAvatar;
